class ComponentQuestion {
  constructor() {
    this._init();
  }

  _init() {
    const questions = document.querySelectorAll('.question__question');

    questions.forEach(function (question) {
      question.addEventListener(
        'click',
        function () {
          (question.parentNode as HTMLElement)?.classList.toggle(
            'question--open'
          );
        },
        false
      );
    });
  }
}

export const componentQuestion = new ComponentQuestion();
